import makeCrud from '@/store/site/localization/crud'

export default makeCrud('ecommerce_abandoned_cart')
